<!-- 选课活动 -->
<template>
<div>
    <div class="index" v-if="!detail.show&&!setting.show">
        <div class="title">
            <div class="span1">
                {{$route.name}}
            </div>	
        </div>

        <div>
			<el-form :inline="true" :model="queryParams" label-width="70px">
				<el-form-item label="">
                    <el-select v-model="queryParams.semester" clearable placeholder="选择学年学期" class="label">
                        <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-select v-model="queryParams.state" clearable placeholder="选择状态" class="label">
                        <el-option v-for="item in stateList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				 <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
                    <el-button type="primary" size="small" @click='add()'>新建</el-button>
                </el-form-item>
			</el-form>

            <div class="table">
                <ul>
                    <li v-for="(item,i) in tableData" :key="item.title+i">
                        <div class="li-title">
                            <span>{{item.title}}</span>
                            <span class="state" :class="{'ing':item.state==='选课中'}">{{item.state}}</span>
                        </div>
                        <div class="li-content">
                            <div class="li-left">
                                <p>
                                    <span>{{item.a}}</span>
                                    <span style="margin-left:20px">{{item.b}}</span>
                                    <span style="margin-left:20px">{{item.c}}</span>
                                </p>
                                <p>{{item.d}}</p>
                                <p>{{item.e}}</p>
                            </div>
                            <div class="li-right">
                                <el-button type="primary" plain size="small" @click='edit()'>编辑</el-button>
                                <el-button type="danger" plain size="small" @click='del()'>删除</el-button>
                                <el-button type="primary" plain size="small" v-if="item.state==='选课中'">提前结束</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="pagination" v-if="tableData.length">
                    <el-pagination background :current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total,prev, pager, next,jumper,sizes" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import api from '@/api/wisdomSchool/index.js'
export default {
    components:{

    },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				semester: '',
				state:'',
				date:'',
				teacher:'',
			},
			stateList:[
                {id:'state1',label:'选课中'},
                {id:'state2',label:'选课结束'},
            ],
			semesterList: [
				{id:'xq1',label:'2021~2022年度下学期'},
				{id:'xq2',label:'2021~2022年度上学期'},
				{id:'xq3',label:'2020~2021年度下学期'},
				{id:'xq4',label:'2020~2021年度上学期'},
				{id:'xq5',label:'2019~2020年度下学期'},
				{id:'xq6',label:'2019~2020年度上学期'},
			],
			teacherList:[],
			tableData: [
				// {title:'知识储备提升活动',state:'选课中',a:'学年学期 2021-2022年度上学期',b:'课程总数 6',c:'招生总数 310',d:'老师开课时间 2021-11-01 00:00 - 2021-11-05  00：00',e:'学生选课时间 2021-11-05 00:00 - 2021-11-15  00：00	'},
                // {title:'天天向上活动',state:'选课结束',a:'学年学期 2021-2022年度上学期',b:'课程总数 8',c:'招生总数 376',d:'老师开课时间 2021-11-11 00:00 - 2021-11-16  00：00',e:'学生选课时间 2021-11-16 00:00 - 2021-11-20  00：00'},
			],
            detail:{
                info:{},
                show:false,
            },
			school_info:JSON.parse(sessionStorage.getItem('classList')),
			semesterArr:JSON.parse(sessionStorage.getItem('semesterList')),
			setting:{
				info:{},
				show:false,
			},
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
			this.setting.show=false;
        },
		toSetting(){
			this.setting.show=true;
		},
        add(){},
        del(item){},
        edit(item){},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: space-between;
		.title-right{
			height: 42px;
			padding: 5px;
			display: flex;
		}
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

    .table{
        width: 100%;
        ul{
            width: 100%;
            height: 100%;
            li{
                height: 152px;
                margin-top: 20px;
                padding: 12px 20px;
                border: 1px solid #ddd;
                border-radius: 5px;
                .li-title{
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #ddd;
                    font-size: 16px;
                    font-weight: bold;
                    .state{
                        font-weight:normal;
                        color: #aaa;
                    }
                    .ing{
                        color: #7CD85B;
                    }
                }
                .li-content{
                    height: 110px;
                    display: flex;
                    align-items: flex-end;
                    justify-content: space-between;
                    .li-left{
                        p{
                            margin-top: 15px;
                            color: #666;
                        }
                    }   
                }
            }
        }
    }
	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
